import { tracked } from '@glimmer/tracking';
import { type GenericChangeset } from 'uplisting-frontend/services/repositories/-base';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { SyncType } from 'uplisting-frontend/components/ui/stay-strategy/v1';

export default class SidebarMlosController extends BaseController {
  syncType = SyncType.mlos;

  queryParams = ['start', 'end'];

  start;
  end;

  @tracked model!: GenericChangeset<ModelRegistry['bulk-mlos']>;
}
